import { useCallback } from 'react';
import { SELECTED_FILTER_KEY } from './useSelectedEpgFilter';
import { STARTED_PAGE_ID, SELECTED_CAROUSEL_CARD_KEY } from '../utils/constants';

export default function useResetFocus(pageId = '') {
  return useCallback(() => {
    sessionStorage.setItem(STARTED_PAGE_ID, pageId);
    sessionStorage.setItem(
      SELECTED_CAROUSEL_CARD_KEY,
      JSON.stringify({ positionCarouselStored: 0 }),
    );
    sessionStorage.setItem('offsetFromStartedPage', 0);
    sessionStorage.setItem('offsetEpg', 0);
    sessionStorage.setItem('initialSectionIndex', 0);
    sessionStorage.setItem('initialSectionIndexEpg', 0);
    sessionStorage.setItem('indexEpgFilterSelected', 0);
    sessionStorage.setItem('savedHeightList', JSON.stringify([]));
    sessionStorage.setItem('parentalBlockedChannelId', '');
    sessionStorage.setItem('wasPreSearchFocused', false);
    sessionStorage.setItem('preSearchFocusedOn', 0);
    sessionStorage.setItem(SELECTED_FILTER_KEY, '');
    sessionStorage.removeItem('liveSectionType');
    sessionStorage.removeItem('focusableItemInMain');
  }, [pageId]);
}
